module.exports = __webpack_public_path__ + "img/desk.e6f23b99.png";